import Upper from "./features/Upper";
import TabNav from "./features/TabNav";
import {useState} from "react";
import Tab1 from "./features/Tab1";
import Tab2 from "./features/Tab2";
import {useParams} from "react-router-dom";
import {useReadInvDetail} from "./hooks/useReadInvDetail";
import {invDetailHistoryMapInit, invDetailHistorySearchParamInit, invDetailInit} from "./state";
import {useReadPresentInvAmount} from "./hooks/useReadPresentInvAmount";
import {InvDetailHistorySearchParamType} from "./interface";
import {useReadPresentInvDetailHistory} from "./hooks/useReadPresentInvDetailHistory";

export default function InvDetail() {
    const {id} = useParams()

    const [invDetailHistorySearchParam, setInvDetailHistorySearchParam] = useState<InvDetailHistorySearchParamType>(invDetailHistorySearchParamInit)
    const [tab, setTab] = useState("tab-1");

    const {data: invDetail} = useReadInvDetail({id: Number(id as string)})
    const {data: presentInvAmount} = useReadPresentInvAmount({id: Number(id as string)})
    const {data: presentInvDetailHistory} = useReadPresentInvDetailHistory({
        param: {
            ...invDetailHistorySearchParam,
            inventoryId: Number(id as string)
        }
    })

    return (
        <>
            <Upper invDetail={invDetail ?? invDetailInit}/>

            <TabNav tab={tab} setTab={setTab}/>

            {tab === "tab-1" && <Tab1 presentInvAmount={presentInvAmount ?? 0}
                                      invDetailHistorySearchParam={invDetailHistorySearchParam}
                                      setInvDetailHistorySearchParam={setInvDetailHistorySearchParam}
                                      presentInvDetailHistory={presentInvDetailHistory ?? invDetailHistoryMapInit}
                                      invDetail={invDetail ?? invDetailInit}
            />}

            {tab === "tab-2" && <Tab2 invDetail={invDetail ?? invDetailInit}/>}
        </>
    );
}